import React from "react"
import { PASSWORD_REQUIREMENTS } from "../utils/password"
import { THEME } from "../config/theme"

interface Props {
  password: string
}

const MET_COLOR = THEME.colors.semantic.success
const UNMET_COLOR = THEME.colors.neutral.light.textSecondary

const PasswordRequirements: React.FC<Props> = ({ password }) => {
  return (
    <ul
      style={{
        listStyle: "none",
        padding: "12px 16px",
        margin: "12px 0",
        background: THEME.colors.neutral.light.background,
        borderRadius: THEME.borderRadius.md,
      }}
    >
      {PASSWORD_REQUIREMENTS.map((req) => {
        const met = req.test(password)
        const color = met ? MET_COLOR : UNMET_COLOR
        return (
          <li
            key={req.label}
            style={{
              fontSize: "13px",
              color,
              display: "flex",
              alignItems: "center",
              lineHeight: "24px",
            }}
          >
            <span
              style={{
                display: "inline-block",
                width: "18px",
                marginRight: "8px",
                fontWeight: "bold",
                color,
              }}
            >
              {met ? "\u2713" : "\u25CB"}
            </span>
            {req.label}
          </li>
        )
      })}
    </ul>
  )
}

export default PasswordRequirements
